import React from "react";
import "./Common_Headings.css"
function Common_Headings({ title }) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="Heading">{title}</h5>
      <span className="see-text">see all</span>
    </div>
  );
}

export default Common_Headings;
